import { useRequiredContext } from "@redotech/react-util/context";
import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import SaleIcon from "@redotech/redo-icons/sale-03.svg";
import SaleFilledIcon from "@redotech/redo-icons/sale-03_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import { LockableSecondaryNavItem } from "./lockable-secondary-nav-item";

export const DiscountRulesItems = memo(function DiscountRulesItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const href = routes.getConversionSubRoute("discount-rules");
  const match = useMatch({ path: href, end: false });

  return (
    <LockableSecondaryNavItem
      buttonLocation={ScheduleDemoButtonLocation.NAV_DISCOUNT_RULES}
      feature={ConversionFeature.DISCOUNT_RULES}
      FilledIcon={SaleFilledIcon}
      friendlyName="Discount rules"
      href={href}
      id="discount-rules"
      selected={!!match}
      UnfilledIcon={SaleIcon}
    />
  );
});
